import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import TabHeading from '@/components/_common/Tabs/TabHeading';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { useAppSelector } from '@/redux/hooks';
import { selectJob } from '@/redux/selectors/jobSelectors';
import { Card, CardContent, Divider, Grid } from '@mui/material';

const JobTabFullInputs = () => {
  const { job_user_inputs } = useAppSelector(selectJob);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Card elevation={0}>
          <CardContent>
            <Grid container justifyContent="space-between" alignItems="center" sx={{ position: 'relative' }}>
              <TabHeading icon={<PolarisIcon icon="info" />}>Full Inputs</TabHeading>
              <Divider />
              <SchemaForm schema={job_user_inputs || {}} formData={{}} readonly formContext={{ rowSpacing: 3, columnSpacing: 4 }} />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default JobTabFullInputs;
